/**
 * Copyright (c) 2024 Spazious, Inc All Rights Reserved
 * Proprietary and confidential
 *
 * Written by Rubeniskov <ruben.lopez@spazious.com>, Fri Feb 16 2024
 */

/**
 * Check if an object has a property
 */
export const hasOwnProperty = (mixed: any, key: string | symbol | number) =>
  mixed !== null && mixed !== undefined ? Object.hasOwnProperty.call(mixed, key) : false;
